<template>
	<div class="container extend-page">
		<header-bar name='扶馨陪诊' :prev='false' />
		<div class="wrap">
			<img class="icon" src="~assets/images/denied.png" />
			<div class="text">无法访问未授权页面</div>
			<div class="link" @click="handlerGoLogin">点击这里登录</div>
		</div>
	</div>
</template>

<script>
	import HeaderBar from 'components/HeaderBar/HeaderBar'
	export default{
		name: 'Denied',
		components: {
			HeaderBar
		},
		data() {
			
		},
		methods: {
			handlerGoLogin: function(){
				this.$router.push({
					path: '/login'
				})
			}
		}
	}
</script>

<style scoped>
.wrap{ padding: 0 0.3rem; display: flex; flex-direction: column; align-items: center;}
.wrap>.icon{ width: 6.9rem; height: 5.3rem;}
.wrap>.text{ height: 0.96rem; line-height: 0.96rem; text-align: center; font-size: 0.32rem; font-weight: 600; color: #333;}
.wrap>.link{ width: calc(7.5rem - 0.6rem); height: 0.88rem; line-height: 0.88rem; margin: 0.6rem 0 0; text-align: center; color: #FFF; font-size: 0.32rem; border-radius: 0.88rem; background: #3f58fd;}
</style>